import * as React from "react"
import type { SVGProps } from "react"
const SvgArrowUpMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M7.5 5.82V13q0 .42.29.71.29.3.71.29c.42-.01.52-.1.71-.29A1 1 0 0 0 9.5 13V5.82l2.9 2.9a1 1 0 0 0 .7.28 1 1 0 0 0 .7-.28 1 1 0 0 0 .27-.7 1 1 0 0 0-.27-.7l-4.6-4.6a1 1 0 0 0-.7-.3q-.4 0-.7.3l-4.6 4.6a1 1 0 0 0-.28.7q0 .43.28.7a1 1 0 0 0 .7.28 1 1 0 0 0 .7-.28z" />
  </svg>
)
export default SvgArrowUpMini
